module.exports = __webpack_public_path__ + "static/img/16071B_X_02_3_4_5_20170802_fit.b795c7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/16071B_X_02_3_4_5_20170802_fit.png
// module id = A5+u
// module chunks = 0